import { Box, Container, Grid, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function AIUseCases() {
  const types = [
    'Improving Patient Access & Better Outcomes',
    'Learning & Development',
    'Continually demonstrating mastery of the prior authorization and payer landscape of the healthcare system',
    'Promote Technical Competencies',
  ];
  return (
    <Box sx={{ pt: 15, pb: 15 }}>
      <Container>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <Typography variant="h2" sx={{ color: 'white', pb: 5 }}>
              {/* Who is CNMAP™ for? */}
              AI Use Cases & Field Reimbursement / Prior Auth
            </Typography>
          </Grid>
          {types &&
            types.length >= 1 &&
            types.map((item) => (
              <>
                <Grid item md={6} xs={12}>
                  <Typography variant="h5" sx={{ color: 'white' }} className="flex align-center">
                    <CheckCircleIcon style={{ marginRight: '7px' }} />
                    {item}
                  </Typography>
                </Grid>
              </>
            ))}
        </Grid>
      </Container>
    </Box>
  );
}
